<template>
    <v-container fluid>
        <v-row style="height: 100vh" class="d-flex align-center justify-center">
            <v-col>
                <div class="d-flex">
                    <h1>{{ $t('journalNotFound') }}</h1>
                    <v-icon large class="ml-3" color="#111111">fa-frown-open</v-icon>
                </div>
                <p class="mt-2 mb-10">{{ $t('sharedJournalNotFound') }}</p>
                <v-btn @click="goToDashboard">{{ $t('goToDashboard') }}</v-btn>
            </v-col>
        </v-row>
    </v-container>
</template>

<script>
    export default {
        name: "SharedNotFound",
        methods: {
            goToDashboard() {
                this.$router.push('/dashboard');
            },
        }
    }
</script>

<style scoped>

</style>


<i18n>
{
    "en":{
        "journalNotFound": "Journal Not Found",
        "sharedJournalNotFound": "The shared journal was not found. Try with another link.",
        "goToDashboard": "Go to dashboard"

    },
    "es":{
        "journalNotFound": "La bitácora no fue encontrada",
        "sharedJournalNotFound": "La bitácora compartida no fue encontrada. Intenta con otro link.",
        "goToDashboard": "Ir al dashboard"
    }
}
</i18n>